// extracted by mini-css-extract-plugin
export default {"container":"Callout_container__E5HkU","visible":"Callout_visible__1rRS3","line":"Callout_line__csG6h","text":"Callout_text__UtmlL"};